import type { ServiceInput, ServiceRow } from '@/hooks/useServices';
import { automationsFromLegacyFields } from '@/lib/preVisitQuestionnaireTiming';
import type { QuestionnaireAutomationDraft } from '@/lib/preVisitQuestionnaireTiming';

export const DEFAULT_SERVICE_FORM: ServiceInput = {
  name: '',
  description: '',
  duration_minutes: 30,
  price_cents: 0,
  currency: 'DKK',
  vat_rate_percent: 25,
  color: '#6366F1',
  is_active: true,
  is_blocker: false,
  auto_send_questionnaires: [],
  pre_visit_questionnaire_template_id: null,
  pre_visit_hours_before: 0,
  pre_visit_delay_after_booking_hours: 0,
  questionnaire_automations: [],
  payment_timing: null,
  deposit_amount_cents: 0,
};

export const DEFAULT_BLOCKER_FORM: ServiceInput = {
  ...DEFAULT_SERVICE_FORM,
  duration_minutes: 60,
  vat_rate_percent: 0,
  color: '#9CA3AF',
  is_blocker: true,
};

export function serviceInputFromRow(
  svc: ServiceRow,
  questionnaireAutomations?: QuestionnaireAutomationDraft[],
): ServiceInput {
  const autoSend = svc.auto_send_questionnaires;
  const automations =
    questionnaireAutomations && questionnaireAutomations.length > 0
      ? questionnaireAutomations
      : automationsFromLegacyFields({
          pre_visit_questionnaire_template_id: svc.pre_visit_questionnaire_template_id,
          pre_visit_hours_before: svc.pre_visit_hours_before,
          pre_visit_delay_after_booking_hours: svc.pre_visit_delay_after_booking_hours,
          auto_send_questionnaires: Array.isArray(autoSend)
            ? autoSend.filter((id): id is string => typeof id === 'string')
            : [],
        });
  return {
    name: svc.name,
    description: svc.description ?? '',
    duration_minutes: svc.duration_minutes,
    price_cents: svc.price_cents,
    currency: svc.currency,
    vat_rate_percent: svc.vat_rate_percent,
    color: svc.color,
    is_active: svc.is_active,
    is_blocker: svc.is_blocker ?? false,
    auto_send_questionnaires: Array.isArray(autoSend)
      ? autoSend.filter((id): id is string => typeof id === 'string')
      : [],
    pre_visit_questionnaire_template_id: svc.pre_visit_questionnaire_template_id ?? null,
    pre_visit_hours_before: svc.pre_visit_hours_before ?? 0,
    pre_visit_delay_after_booking_hours: svc.pre_visit_delay_after_booking_hours ?? 0,
    questionnaire_automations: automations,
    payment_timing: (svc.payment_timing as ServiceInput['payment_timing']) ?? null,
    deposit_amount_cents: svc.deposit_amount_cents ?? 0,
  };
}
